import React from 'react';
import { useTranslation } from 'react-i18next';
import { useApp, showUsageTerms } from '../store';

export const UsageTerms: React.FC = () => {
  const { t } = useTranslation();
  const { dispatch } = useApp();

  const handleClose = () => {
    showUsageTerms(false, dispatch);
  };

  return (
    <>
      <div className={'usageContainer'}>
        <div className={'usage'}>
          <h2>{t('usageTermsTitle')}</h2>
          <h3>{t('usageTermsOwnerTitle')}</h3>
          <p>{t('usageTermsOwnerP1')}</p>
          <p>{t('usageTermsOwnerP2')}</p>
          <p>{t('usageTermsOwnerP3')}</p>

          <h3>{t('usageTermsObligationsTitle')}</h3>
          <p>{t('usageTermsObligationsP1')}</p>

          <h3>{t('usageTermsLoggingTitle')}</h3>
          <p>{t('usageTermsLoggingP1')}</p>
          <p>{t('usageTermsLoggingP2')}</p>
          <p>{t('usageTermsLoggingP3')}</p>
        </div>
        <button className="primary" onClick={handleClose}>
          {t('close')}
        </button>
      </div>
    </>
  );
};
